<template>
  <div class="application" id="unsupported-browser-page">
    <el-container>
      <el-header style="height: 86px;background-color: #151515;">
        <LoginPageHeader />
      </el-header>
      <div style="flex: 1 0 auto; text-align: center; margin-top: 40px">
        <div>
          <h1 style="font-size: 42px; margin: 6px;">Page not found</h1>
        </div>
        <p class="mb-2 mt-4 unsupported-text">
          You seem to have stumbled upon a page that doesn't exist.
        </p>
        <img
          src="../../assets/images/backgrounds/404.svg"
          width="400px"
          style="margin-top: 75px"
        />
      </div>
      <el-footer height="40px">
        <LoginPageFooter :darkText="true" />
      </el-footer>
    </el-container>
  </div>
</template>

<script type="text/babel">
import LoginPageFooter from "@/components/layout/Footer.vue";
import LoginPageHeader from "@/components/layout/Header.vue";
export default {
  name: "NotFoundPage",
  components: {
    LoginPageHeader,
    LoginPageFooter
  },
  data() {
    return {};
  }
};
</script>
<style>
@import "../../styles/css/login.css";
</style>
